export const WARNING_TYPE = {
  normal: "normal",
  custom: "custom",
};
